import { CountryWithCalendarsDTO } from 'entities/calendar';
import { CalendarsList } from '../CalendarsList';

const ExpandedCalendarsList = (record: CountryWithCalendarsDTO): React.ReactElement => {
  return <CalendarsList record={record} />;
};

export { ExpandedCalendarsList };
